module.exports = __webpack_public_path__ + "static/home_ch_standard-6b74ed287d3aceae678a1317c5e66fd5.jpg";